import React, { PureComponent } from 'react';
import { connect } from 'react-redux'
import moment from 'moment'
import DatePicker from 'react-datepicker'
import FormNewLine from '../common/FormNewLine';
import TextInput from '../common/TextInput';
import apiClient from '../../apis'
import { formatNumberWithComma } from '../../common/util'
import { Formatter } from '../../utilities/Formatter';

export class CreateCampaignForm extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        campaignName: '',
        startDate: '',
        endDate: '',
        budget: ''
      }
    }
  }

  save = (skipRefreshFunc=false) => {
    if(!this.state.data.campaignName){
      alert("กรุณากรอกชื่อแคมเปญ");
      return Promise.reject();
    }
    else if(!this.state.data.budget) {
      alert("กรุณากรอกงบประมาณ");
      return Promise.reject();
    }
    else if(!this.state.data.startDate || !this.state.data.endDate){
      alert("กรุณากรอกวันที่ให้ครบ");
      return Promise.reject();
    }
    else if(moment(this.state.data.endDate, 'YYYY-MM-DD') < moment(this.state.data.startDate, 'YYYY-MM-DD')){
      alert("วันที่ไม่ถูกต้อง กรุณาใส่วันที่ใหม่");
      return Promise.reject();
    }
    else{
      const p = apiClient.campaign.createCampaign(this.state.data).then((result,err) => {
        if(result.key) {
          return result
        }
        else {
          return console.error(err)
        }
      })
      return p
    }
  }

  handleDateChange(datetime, key) {
    const data = this.state.data
    data[key] = moment(datetime._d).format('YYYY-MM-DD')
    this.setState({
        [key]: datetime
    })
  }

  render() {
    return (
      <div className="d-flex flex-column" style={{ flexGrow: 1 }}>
          <div className="row">
              <h3 className="col-sm-4" style={{color: 'grey'}}>ข้อมูลแคมเปญ</h3>
              <FormNewLine />
              <div className="col-sm-6">
                <TextInput 
                  name="campaignName"
                  placeholder="ชื่อ"
                  target={ this }
                  stateKey="data"
                  required={true}
                />
              </div>
              <div className="col-sm-2.5">
                <DatePicker
                  className="form-control input w-fit-content calendar-image"
                  placeholderText="วันที่เริ่ม"
                  selected={ this.state.startDate }
                  onChange={ (date) => this.handleDateChange(date ? date : '', 'startDate') }
                  dateFormat={this.state.startDate ? `${Formatter.formatDateTh(Formatter.createDate(this.state.startDate))}` : ''}
                  shouldCloseOnSelect={ true }
                  disabledKeyboardNavigation
                  required={ true }
                />
              </div>
              <div className="col-sm-3">
                <DatePicker
                  className="form-control input w-fit-content calendar-image"
                  placeholderText="วันที่สิ้นสุด"
                  selected={ this.state.endDate }
                  dateFormat={this.state.endDate ? `${Formatter.formatDateTh(Formatter.createDate(this.state.endDate))}` : ''}
                  onChange={ (date) => this.handleDateChange(date ? date : '', 'endDate') }
                  minDate={ moment(this.state.data.startDate, 'YYYY-MM-DD').add(1, 'day') }
                  shouldCloseOnSelect={ true }
                  disabledKeyboardNavigation
                  disabled={ this.state.data.startDate ? false : true }
                  required={ true }
                />
              </div>
              <FormNewLine />
              <div className="col-sm-6">
                <TextInput
                  name="budget"
                  placeholder="งบประมาณที่ใช้ (บาท)"
                  target={ this }
                  renderFormatter={value => formatNumberWithComma(value)}
                  dataFormatter={value => value.replace(/,/g, '')}
                  stateKey="data"
                  required={true}
                />
              </div>
          </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
      options: state.other.options,
  }
}

CreateCampaignForm = connect(mapStateToProps, null, null, { withRef: true })(CreateCampaignForm)
export default CreateCampaignForm;